<template>
  <div>
    <marquee-text></marquee-text>
    <b-row class="match-height" align-h="center">
      <b-col md="3">
        <burrow-tvl-card />
      </b-col>
      <b-col md="7">
        <burrow-tvl-chart />
      </b-col>
      <b-col md="6">
        <burrow-traffic-chart />
      </b-col>
    </b-row>
    <b-row class="match-height" align-h="center">
      <b-col md="2">
        <statistic-card-vertical
          color="success"
          icon="TruckIcon"
          :statistic="`$${dFormatter(usdc)}`"
          statistic-title="$USDC Locked"
        />
      </b-col>
      <b-col md="2">
        <statistic-card-vertical
          color="success"
          icon="TruckIcon"
          :statistic="`$${dFormatter(stnear)}`"
          statistic-title="$stNEAR Locked"
        />
      </b-col>
    </b-row>
    <b-row class="match-height" align-h="center">
      <b-col md="2">
        <statistic-card-horizontal
            icon="CpuIcon"
            color="success"
            :statistic="`$${dFormatter(usn)}`"
            statistic-title="$USN Locked"
        />
        <statistic-card-horizontal
            icon="CpuIcon"
            color="success"
            :statistic="`$${dFormatter(usdt)}`"
            statistic-title="$USDT Locked"
        />
        <statistic-card-horizontal
            icon="CpuIcon"
            color="success"
            :statistic="`$${dFormatter(linear)}`"
            statistic-title="$LiNEAR Locked"
        />
      </b-col>
      <b-col md="2">
        <statistic-card-horizontal
            icon="CpuIcon"
            color="success"
            :statistic="`$${dFormatter(brrr)}`"
            statistic-title="$BRRR Locked"
        />
        <statistic-card-horizontal
            icon="CpuIcon"
            color="success"
            :statistic="`$${dFormatter(near)}`"
            statistic-title="$NEAR Locked"
        />
        <statistic-card-horizontal
            icon="CpuIcon"
            color="success"
            :statistic="`$${dFormatter(aurora)}`"
            statistic-title="$AURORA Locked"
        />
      </b-col>
      <b-col md="2">
        <statistic-card-horizontal
            icon="CpuIcon"
            color="success"
            :statistic="`$${dFormatter(dai)}`"
            statistic-title="$DAI Locked"
        />
        <statistic-card-horizontal
            icon="CpuIcon"
            color="success"
            :statistic="`$${dFormatter(wbtc)}`"
            statistic-title="$WBTC Locked"
        />
        <statistic-card-horizontal
            icon="CpuIcon"
            color="success"
            :statistic="`$${dFormatter(weth)}`"
            statistic-title="$WETH Locked"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { dFormatter } from '@/@core/utils/filter'
import MarqueeText from '@/layouts/components/PricesTicker.vue'
import BurrowTrafficChart from './charts/BurrowTrafficChart.vue'
import BurrowTvlCard from './charts/BurrowTVLCard.vue'
import BurrowTvlChart from './charts/BurrowTVLChart.vue'
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
import axios from 'axios'

export default {
  components: {
    BRow,
    BCol,

    MarqueeText,
    BurrowTrafficChart,
    BurrowTvlCard,
    BurrowTvlChart,
    StatisticCardVertical,
    StatisticCardHorizontal,
  },
  data() {
    return {
      usn: 0,
      usdt: 0,
      linear: 0,
      brrr: 0,
      near: 0,
      usdc: 0,
      aurora: 0,
      stnear: 0,
      dai: 0,
      wbtc: 0,
      weth: 0,
    }
  },
  methods: {
    dFormatter,
  },
  mounted() {    
    axios.get('https://api.llama.fi/protocol/burrow')
    .then(response => {
      var el = response.data.tokensInUsd[response.data.tokensInUsd.length - 1]
      this.usn = el.tokens.usn;
      this.usdt = el.tokens["USDT"];
      this.linear = el.tokens["LINEAR"];
      this.brrr = el.tokens.BRRR;
      this.near = el.tokens.NEAR;
      this.usdc = el.tokens["USDC"];
      this.aurora = el.tokens["aurora-near"] || el.tokens["AURORA"];
      this.stnear = el.tokens["STNEAR"];
      this.dai = el.tokens.dai || el.tokens["DAI"];
      this.wbtc = el.tokens["wrapped-bitcoin"] || el.tokens["WBTC"];
      this.weth = el.tokens.WETH;
    })
    .catch(e => console.error(e))

  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
